import React from "react";
import moment from "moment";
import Cookies from 'universal-cookie';
import { styled } from '@mui/material/styles';
import _default from "../themes/default";
import _ from 'lodash';

// components
import PageTitle from "../components/PageTitle/PageTitle";
import DatePickerIta from "../widgets/DatePickerMUI";
import Loading from "../components/Loading";
import LoadingButton from '@mui/lab/LoadingButton';
import getClienti from "../services/getClienti";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Alert, InputAdornment, MenuItem, Snackbar, Stack, TextField, FormControl, InputLabel, Select, Typography, Paper, Table, TableContainer, TableBody, TableCell, TableRow, TableHead } from "@mui/material";
import MyModalMail from "../widgets/MyModalMail";
import SettingsTitle from "../widgets/SettingsTitle";
import ManageRowSettings from "../widgets/ManageRowSettings";
import CustomInfo from "../components/CustomInfo";

// apis
import getAgenti from "../services/getAgenti";
import getFunzionari from "../services/getFunzionari";
import getOrdine from "../services/getOrdine";
import getCliente from "../services/getCliente";
import getProdotti from "../services/getProdotti";
import getGiacenze from "../services/getGiacenze";
import getGiacenzeUscita from "../services/getGiacenzeUscita";
import editOrdineConferma from "../services/editOrdineConferma";
import editOrdineConcluso from "../services/editOrdineConcluso";
import editOrdine from "../services/editOrdine";
import editOrdineCs from "../services/editOrdineCs";
import editOrdineListaPronta from "../services/editOrdineListaPronta";
import intoOrder from "../services/intoOrder";
import checkToken from "../services/checkToken";
import editApprovato from "../services/editApprovato";
import editBloccato from "../services/editBloccato";
import inviaCliente from "../services/inviaCliente";
import editOrdineDdt from "../services/editOrdineDdt";
import deleteOrdineDdt from "../services/deleteOrdineDdt";
import deleteOrdineConferma from "../services/deleteOrdineConferma";
import visualizzaPreventivo from "../services/visualizzaPreventivo";
import addReminder from "../services/addReminder";
import editSecondaApprovazione from "../services/editSecondaApprovazione";
import editTerzaApprovazione from "../services/editTerzaApprovazione";
import createListaCarico from "../services/createListaCarico";
import MyModalDdt from "../widgets/MyModalDdt";
import MyModalMailConfermaData from "../widgets/MyModalMailConfermaData";
import updateArrayDtt from "../services/updateArrayDdt";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
let current = cookies.get('ordine', { path: '/' });
let userType = cookies.get('userType', { path: '/' });

const rowTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 4,
    borderBottom: '0.3px solid #c1c1c1',
    marginTop: 30,
    marginBottom: 20
}

const groupInput = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15
}

const inputStyle = {
    borderRadius: 4,
    width: '80%',
    paddingTop: 9,
    paddingBottom: 9,
    paddingInline: 9,
    outlineColor: '#4A4A4A',
    outlineWidth: "thin"
}

const smallInputStyle = {
    borderRadius: 4,
    width: '45%',
    marginLeft: 5,
    paddingTop: 9,
    paddingBottom: 9,
    paddingInline: 9,
    outlineColor: '#4A4A4A',
    outlineWidth: "thin"
}

const Android12Switch = styled(Switch)(({ theme }) => ({
    margin: 8,
    padding: 8,
    '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            width: 16,
            height: 16,
        },
        '&:before': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        '&:after': {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main),
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
    },
})
);

export default class EditOrdine extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            agenti: [],
            clienti: [],
            funzionari: [],
            tecnico: false,
            gru: false,
            autotreno: false,
            indirizzo: '',
            is_preventivo: 0,
            prodotti: [],
            email_inviata: 0,
            crea_ddt: 0,
            valueState: [],
            pdfConferma: '',
            linkPdfConferma: '',
            linkPdfDdt: [],
            modalMail: {
                show: false,
                link: '',
            },
            modalMailConfermaData: {
                show: false,
                link: '',
            },
            agente: '',
            funzionario: '',
            segnalatore: '',
            legato_cliente: true,
            legacy_fatturazione: [],
            legacy_incasso: [],
            legacy_provvigioni: [],
            legacy_provvigioniSegnalatore: [],
            fatturazione: [],
            incasso: [],
            provvigioni: [],
            provvigioniSegnalatore: [],
            fatPerc: 0,
            incPerc: 0,
            totale: '',
            fatture: [],
            incassi: [],
            prev_provvigioni: [],
            prev_provvigioniSegnalatore: [],
            approvata: false,
            seconda_approvazione: false,
            email_inviata_preventivo: false,
            link_ddt: [],
            modalDdt: {
                show: false,
                id: '',
                ddt: '',
            },
            conclusa: false,
            is_parziale: null,
        };
    }

    async componentDidMount() {
        this.reload()
    }

    updatePercentage() {
        let fatPerc = 0;
        let incPerc = 0;
        this.state.fatturazione.forEach((fatturazione) => {
            fatPerc += parseInt(fatturazione.percentage);
        })
        this.state.incasso.forEach((incasso) => {
            incPerc += parseInt(incasso.percentage);
        })
        this.setState({ fatPerc, incPerc });
    }

    async reload() {
        this.setState({ loading: true })
        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });
        current = cookies.get('ordine', { path: '/' });
        userType = cookies.get('userType', { path: '/' });

        const check = await checkToken(username, token, true);
        userType = check.utente.tipo;

        let ordiniLink = '';
        let preventiviLink = '';

        let ordine = await getOrdine(username, token, current);
        let cliente = await getCliente(username, token, ordine.id_cliente);
        let res = await getClienti(username, token);
        res.forEach((c, i) => {
            res[i].label = c.ragione_sociale
        })
        let giacenze = await getGiacenze(username, token);
        let giacenze_uscita = await getGiacenzeUscita(username, token)

        let prodottiList = await getProdotti(username, token)
        let agenti = await getAgenti(username, token);
        agenti.forEach((agente) => agente['label'] = agente.ragione_sociale)

        let funzionari = await getFunzionari(username, token);
        funzionari.forEach((funzionario) => funzionario['label'] = funzionario.ragione_sociale)

        let prodotti = [];
        prodotti = [...JSON.parse(ordine.prodotti)];

        prodotti = prodotti.map((prodotto, i) => {
            let giacenza = giacenze.find(g => g.id_prodotto === prodotto.id_prodotto);
            let giacenza_uscita = giacenze_uscita.find(g => g.id === prodotto.id_prodotto);
            return {
                ...prodotto,
                giacenza: giacenza ? giacenza.giacenza : 0,
                giacenza_uscita: giacenza_uscita ? giacenza_uscita.quantita : 0
            }
        })

        switch (userType) {
            case '0':
                ordiniLink = '#/app/ordini';
                preventiviLink = '#/app/preventivi';
                break;
            case '1':
                ordiniLink = '#/tecnico/ordini';
                preventiviLink = '#/tecnico/preventivi';
                break;
            case '3':
                ordiniLink = '#/commerciale/ordini';
                preventiviLink = '#/commerciale/preventivi';
                break;
            case '4':
                ordiniLink = '#/service/ordini';
                preventiviLink = '#/service/preventivi';
            default:
                break;
        }

        let segnalatore = null;
        let agente = null;
        let agente_segnalatore = null;

        if (ordine.id_agente) {
            agente_segnalatore = ordine.id_agente.split(';');
            if(agente_segnalatore[0]) {
                agente = agente_segnalatore[0];
            }
            if(agente_segnalatore[1]) {
                segnalatore = agente_segnalatore[1];
            }
        }

        this.setState({
            clienti: res,
            cliente: parseInt(ordine.id_cliente),
            descrizione: ordine.descrizione,
            prodotti: prodotti,
            tecnico: ordine.richiesto_tecnico === '1',
            autotreno: ordine.passa_autotreno === '1',
            gru: ordine.richiesta_gru === '1',
            indirizzo: ordine.indirizzo_cantiere || '',
            costoTecnico: parseFloat(ordine.costo_tecnico),
            is_preventivo: ordine.is_preventivo,
            totale: parseFloat(ordine.totale_ordine),
            sopralluoghi: JSON.parse(ordine.sopralluoghi) || [],
            email_inviata: parseInt(ordine.email_inviata),
            crea_ddt: parseInt(ordine.crea_ddt),
            rif: ordine.rif,
            id: ordine.id,
            linkPdfConferma: ordine.link_conferma || '',
            linkPdfDdt: JSON.parse(ordine.ddt_pdf) || [],
            loading: false,
            prodottiList,
            ordiniLink,
            preventiviLink,
            isUserType: parseInt(userType),
            approvato: ordine.approvata === '1',
            seconda_approvazione: ordine.seconda_approvazione === '1',
            terza_approvazione: ordine.terza_approvazione === '1',
            bloccato: ordine.blocco === '1',
            cs_data: ordine.cs_data,
            data_pronto: ordine.cs_data === "1" ? ordine.data_pronto : "",
            data_consegna: ordine.cs_data === "1" ? ordine.data_consegna : "",
            data_creazione: ordine.data_creazione,
            lista_pronta: ordine.lista_pronta === '1',
            conferma_magazzino: ordine.conferma_magazzino === '1',
            conferma_inviata: ordine.conferma_inviata === '1',
            conferma_cliente: ordine.conferma_cliente === '1',
            ragione_sociale: ordine.ragione_sociale,
            email: ordine.email,
            fatturazione: JSON.parse(ordine.fatturazione),
            incasso: JSON.parse(ordine.pagamento),
            provvigioni: JSON.parse(ordine.provvigioni),
            provvigioniSegnalatore: JSON.parse(ordine.segnalatore),
            legacy_fatturazione: JSON.parse(cliente.fatturazione),
            legacy_incasso: JSON.parse(cliente.pagamento),
            legacy_provvigioni: JSON.parse(cliente.provvigioni),
            legacy_provvigioniSegnalatore: JSON.parse(cliente.segnalatore),
            riferimento_cantiere: ordine.cantiere,
            legato_cliente: ordine.legato_cliente === '1',
            totale: ordine.totale_ordine,
            dc_ideale: ordine.dc_ideale,
            agenti,
            funzionari,
            approvata: ordine.approvata === '1',
            concluso_magazzino: ordine.concluso_magazzino === '1',
            old_data_pronto: ordine.cs_data === "1" ? ordine.data_pronto : "",
            old_data_consegna: ordine.cs_data === "1" ? ordine.data_consegna : "",
            email_inviata_preventivo: ordine.email_inviata_preventivo === "1",
            link_ddt: JSON.parse(ordine.link_ddt) || [],
            conclusa: ordine.conclusa === '1',
            is_parziale: ordine.is_parziale === '1',
            agente: agente,
            funzionario: ordine.id_funzionario,
            segnalatore: segnalatore,
        }, () => {
            this.updatePercentage()
            this.elaborateScheduleFatturazione()
            this.elaborateScheduleIncassi()
            this.elaborateScheduleProvvigioni()
            this.elaborateScheduleProvvigioniSegnalatore()
        })
    }

    async onReload() {

    }

    close() {
        let modalMail = this.state.modalMail;
        modalMail.show = false;
        this.setState({ modalMail });
    }

    closeConfermaData() {
        let modalMailConfermaData = this.state.modalMailConfermaData;
        modalMailConfermaData.show = false;
        this.setState({ modalMailConfermaData });
    }

    handleError() {
        this.setState({ sendError: true });
    }

    async onChangePdfConferma(username, token, base64_payload, rif, id_ordine) {
        const res = await editOrdineConferma(username, token, base64_payload, rif, id_ordine);
        if (res.result === "ok") {
            this.setState({ linkPdfConferma: res.link });
        }
    }

    async onChangePdfDdt(username, token, base64_payload, rif, id_ordine, index) {
        const res = await editOrdineDdt(username, token, base64_payload, rif, id_ordine, index);
        if (res.result === "ok") {
            this.setState({ linkPdfDdt: JSON.parse(res.link) });
            addReminder(username, token, !this.state.is_parziale ? 'Caricato  DDT firmato ' + res.rif : 'Caricato DDT firmato ordine parziale ' + res.rif, 'amministrazione', 'ordine', this.state.id)
        }
    }

    async onDeletePdfConferma(username, token, id, rif) {
        const res = await deleteOrdineConferma(username, token, id, rif);
        if (res.result === "ok") {
            this.setState({ linkPdfConferma: '' });
        } else {
            console.log(res)
        }
    }

    async onDeletePdfDdt(username, token, id_ordine, rif, index) {
        const res = await deleteOrdineDdt(username, token, id_ordine, rif, index);
        if (res.result === "ok") {
            this.setState({ linkPdfDdt: JSON.parse(res.link) });
        } else {
            console.log(res)
        }
    }

    async loadCliente(id) {
        let cliente_selezionato = await getCliente(username, token, id);

        this.setState({
            fatturazione: cliente_selezionato.fatturazione ? JSON.parse(cliente_selezionato.fatturazione) : [],
            incasso: cliente_selezionato.pagamento ? JSON.parse(cliente_selezionato.pagamento) : [],
            provvigioni: cliente_selezionato.provvigioni ? JSON.parse(cliente_selezionato.provvigioni) : [],
            provvigioniSegnalatore: cliente_selezionato.segnalatore ? JSON.parse(cliente_selezionato.segnalatore) : [],
            legacy_fatturazione: cliente_selezionato.fatturazione ? JSON.parse(cliente_selezionato.fatturazione) : [],
            legacy_incasso: cliente_selezionato.pagamento ? JSON.parse(cliente_selezionato.pagamento) : [],
            legacy_provvigioni: cliente_selezionato.provvigioni ? JSON.parse(cliente_selezionato.provvigioni) : [],
            legacy_provvigioniSegnalatore: cliente_selezionato.segnalatore ? JSON.parse(cliente_selezionato.segnalatore) : [],
        })

        this.setState(() => ({ cliente: null, prodotti: [] }), async () => {
            this.calcolaTotale();
            let cliente = await getCliente(username, token, id);
            let prodotti = await getProdotti(username, token);
            let prodottiCliente = cliente.prodotti_custom ? JSON.parse(cliente.prodotti_custom) : [];
            prodotti.forEach((p, i) => {
                let nuovoCosto = prodottiCliente.find(prodotto => prodotto.prodottoId === p.id);
                if (nuovoCosto)
                    prodotti[i].prezzo = nuovoCosto.price;
            });
            this.setState({ cliente: id, prodottiList: prodotti });
        });
    }


    addInput(param) {
        let obj = { id_prodotto: null, label: '', prezzo: '', quantita: null }
        let new_array = [...this.state[param], obj]
        this.setState({ [param]: new_array })
    }

    addInputPagamenti(type) {
        let obj = { percentage: 0, days: '', from: 'DO' }
        let arr = this.state[type];
        arr.push(obj);
        this.setState({ [type]: arr }, () => this.updatePercentage());
    }

    calcolaTotale() {
        let totale = 0;
        this.state.prodotti.forEach((prodotto) => {
            totale += (parseFloat(prodotto.prezzo) * parseInt(prodotto.quantita));
        })
        if (this.state.tecnico) {
            totale += parseFloat(this.state.costoTecnico);
        }
        this.setState({ totale: totale.toFixed(2) * 1.22 })
    }

    handleCloseAlert = () => {
        this.setState({ toastAlert: false, toastMessage: '', toastSeverity: 'success' })
        if (this.state.isUserType === 0) {
            window.location.href = '/#/app/ordini';
        }
    }

    canEdit() {

        if (this.state.isUserType === 0) {
            return true;
        }

        if (this.state.approvata) {
            return false;
        }

        if (this.state.isUserType === 3) {
            if (this.state.is_preventivo === '1') {
                return true;
            } else {
                return false;
            }
        }

        return false;
    }

    canNotEdit() {

        if (this.state.isUserType === 0) {
            return false;
        }

        if (this.state.approvata) {
            return true;
        }

        if (this.state.isUserType === 3) {
            if (this.state.is_preventivo === '1') {
                return false;
            } else {
                return true;
            }
        }

        return true;
    }

    ordineProntoChiusura() {
        return this.state.link_ddt.every((ddt, i) => this.state.linkPdfDdt[i] !== "")
    }

    render() {

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <>
                {
                    this.state.modalMailConfermaData.show && <MyModalMailConfermaData modal={this.state.modalMailConfermaData} title={"Personalizza la tua email"} onClose={this.closeConfermaData.bind(this)} handleError={() => this.handleError()} onReload={() => this.reload()} />
                }
                {
                    this.state.modalMail.show && <MyModalMail modal={this.state.modalMail} title={"Personalizza la tua email"} onClose={this.close.bind(this)} onReload={() => this.reload()} />
                }
                {
                    this.state.modalDdt.show && <MyModalDdt admin modal={this.state.modalDdt} title={"Personalizza la tua email"} onClose={
                        () => {
                            let modalDdt = this.state.modalDdt;
                            modalDdt.show = false;
                            this.setState({ modalDdt });
                        }
                    } onReload={() => this.reload()} />
                }
                <Stack spacing={2} sx={{ width: '100%' }}>
                    <Snackbar open={this.state.toastAlert} autoHideDuration={2000} onClose={this.handleCloseAlert} anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
                        <Alert onClose={this.handleCloseAlert} severity={this.state.toastSeverity} sx={{ width: '100%', backgroundColor: '#adff7f', marginTop: 10 }}>
                            {this.state.toastMessage}
                        </Alert>
                    </Snackbar>
                </Stack>
                <PageTitle title={'Modifica documento commerciale' + (this.state.rif ? `: ${this.state.rif}` : '')} />

                {this.state.bloccato && (
                    <Alert severity="error" sx={{ marginTop: 2, marginBottom: 5 }}>Questo {this.state.is_preventivo === '1' ? 'preventivo' : 'ordine'} è stato bloccato. {this.state.isUserType !== 0 ? 'Contatta l\'amministrazione per maggiori informazioni.' : ''}</Alert>
                )}

                <Stack spacing={3}>
                    <Stack spacing={1} direction={'row'}>
                        {/* CLIENTI */}
                        <TextField
                            select
                            sx={{ flexGrow: 1, }}
                            label="Cliente"
                            value={this.state.cliente}
                            InputProps={{ readOnly: this.canNotEdit() }}
                            onChange={(e) => {
                                this.setState({ cliente: e.target.value });
                                this.loadCliente(e.target.value);
                            }}
                        >
                            {
                                this.state.clienti.map((cliente_map, i) => {
                                    return (
                                        <MenuItem key={i + cliente_map.id} value={cliente_map.id}>{cliente_map.label}</MenuItem>
                                    )
                                })
                            }
                        </TextField>
                        <TextField
                            sx={{ flexGrow: 1, marginLeft: 2 }}
                            label="Riferimento"
                            value={this.state.rif}
                            InputProps={{ readOnly: this.canNotEdit() }}
                            onChange={(e) => {
                                this.setState({ rif: e.target.value });
                            }}
                        />
                        {
                            (this.state.isUserType === 3 || this.state.isUserType === 1 || this.state.isUserType === 0) && (
                                <FormControlLabel
                                    sx={{ marginTop: '5px !important' }}
                                    disabled={!this.state.cliente || this.canNotEdit()}
                                    control={<Android12Switch checked={this.state.legato_cliente}
                                        onChange={() => {
                                            this.setState({ legato_cliente: !this.state.legato_cliente }, () => {
                                                if (this.state.legato_cliente) {
                                                    this.setState({
                                                        fatturazione: this.state.legacy_fatturazione,
                                                        incasso: this.state.legacy_incasso,
                                                        provvigioni: this.state.legacy_provvigioni,
                                                        provvigioniSegnalatore: this.state.legacy_provvigioniSegnalatore,
                                                    })
                                                }
                                            })
                                            this.updatePercentage()
                                        }}
                                    />}
                                    label="Mantieni regole del cliente"
                                />
                            )
                        }
                    </Stack>

                    {/* DESCRIZIONE */}
                    <TextField
                        rows={4}
                        fullWidth
                        multiline
                        variant="outlined"
                        label={'Descrizione'}
                        value={this.state.descrizione}
                        InputProps={{ readOnly: this.canNotEdit() }}
                        onChange={(e) => { this.setState({ descrizione: e.target.value }) }
                        } />
                </Stack>

                {
                    this.state.isUserType !== 4 &&
                    <Stack spacing={3} sx={{ flex: 1, marginTop: 5 }} direction={'row'}>
                        {/* AGENTE */}
                        <FormControl sx={{ flexGrow: 1 }}>
                            <InputLabel>Agente</InputLabel>
                            <Select label="Agente"
                                value={this.state.agente ? this.state.agente : 'Nessun agente'}
                                inputProps={{ readOnly: this.canNotEdit() }}
                                onChange={(e) => {
                                    this.setState({ agente: e.target.value })
                                }}
                            >
                                <MenuItem value={'Nessun agente'}>Nessun agente</MenuItem>
                                {
                                    this.state.agenti.map((agente, i) => {
                                        return (
                                            <MenuItem key={i} value={agente.id}>{agente.ragione_sociale}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        {/* SEGNALATORE */}
                        <FormControl sx={{ flexGrow: 1 }}>
                            <InputLabel>Segnalatore</InputLabel>
                            <Select label="Segnalatore"
                                value={this.state.segnalatore ? this.state.segnalatore : 'Nessun segnalatore'}
                                inputProps={{ readOnly: this.canNotEdit() }}
                                onChange={(e) => {
                                    this.setState({ segnalatore: e.target.value })
                                }}
                            >
                                <MenuItem value={'Nessun segnalatore'}>Nessun segnalatore</MenuItem>
                                {
                                    this.state.agenti.map((segnalatore, i) => {
                                        return (
                                            <MenuItem key={i} value={segnalatore.id}>{segnalatore.ragione_sociale}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        {/* FUNZIONARIO */}
                        <FormControl sx={{ flexGrow: 1 }}>
                            <InputLabel>Funzionario</InputLabel>
                            <Select label="Funzionario"
                                value={this.state.funzionario ? this.state.funzionario : 'Nessun funzionario'}
                                inputProps={{ readOnly: this.canNotEdit() }}
                                onChange={(e) => {
                                    this.setState({ funzionario: e.target.value })
                                }}
                            >
                                <MenuItem value={'Nessun funzionario'}>Nessun funzionario</MenuItem>
                                {
                                    this.state.funzionari.map((funzionario, i) => {
                                        return (
                                            <MenuItem key={i} value={funzionario.id}>{funzionario.nome + ' ' + funzionario.cognome}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Stack>
                }

                {/* RIFERIMENTO CANTIERE */}
                <Stack spacing={2} sx={{ flex: 1, marginTop: 5 }}>
                    <TextField InputProps={{ readOnly: this.canNotEdit() }} fullWidth variant="outlined" label={'Riferimento cantiere'} value={this.state.riferimento_cantiere} onChange={(e) => { this.setState({ riferimento_cantiere: e.target.value }) }} />
                    <TextField InputProps={{ readOnly: this.canNotEdit() }} InputLabelProps={{ shrink: this.state.indirizzo }} fullWidth variant="outlined" label={'Indirizzo cantiere'} value={this.state.indirizzo} onChange={(e) => { this.setState({ indirizzo: e.target.value }) }} />
                </Stack>

                {!isNaN(parseInt(this.state.cliente)) && (
                    <>
                        <Stack spacing={3} sx={{ flex: 1 }}>

                            {/* ADD PRODOTTI */}
                            <div style={rowTitle}>
                                <SettingsTitle title="Prodotti" />
                                {this.canEdit() && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInput('prodotti')} />}
                            </div>
                            {/* SELECT PRODOTTI */}
                            <div>
                                {
                                    this.state.prodotti.map((el, i) => {
                                        return (
                                            <div key={i} style={groupInput}>
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} >
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Prodotto"
                                                        value={el.id_prodotto}
                                                        InputProps={{ readOnly: this.canNotEdit() }}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.prodotti]
                                                            arr[i].label = e.target.value;
                                                            arr[i].prezzo = this.state.prodottiList.find((n) => n.id === e.target.value).prezzo;
                                                            arr[i].id_prodotto = this.state.prodottiList.find((n) => n.id === e.target.value).id;
                                                            arr[i].quantita = 1;
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }}
                                                    >
                                                        {
                                                            this.state.prodottiList.map((prodotto, i) => {
                                                                return (
                                                                    <MenuItem key={i + prodotto.nome} value={prodotto.id}>{prodotto.nome}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </TextField>

                                                    {/* PREZZO PRODOTTI */}
                                                    {/* QUANTITA */}
                                                    <TextField
                                                        type="number"
                                                        variant="outlined"
                                                        label={'Quantità'} value={el.quantita}
                                                        InputLbelProps={{ shrink: el.quantita }}
                                                        InputProps={{ readOnly: this.canNotEdit() }}
                                                        onChange={(e) => {
                                                            let arr = this.state.prodotti
                                                            arr[i].quantita = e.target.value
                                                            this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                        }} />

                                                    {this.state.isUserType !== 4 &&
                                                        <>
                                                            {/* PREZZO UNITARIO */}
                                                            <TextField
                                                                type="number"
                                                                variant="outlined"
                                                                label={'Prezzo Unità'} value={el.prezzo}
                                                                InputProps={{ endAdornment: <InputAdornment position="end">€</InputAdornment>, readOnly: this.canNotEdit() }}
                                                                onChange={(e) => {
                                                                    let arr = this.state.prodotti
                                                                    arr[i].prezzo = e.target.value
                                                                    this.setState(() => ({ prodotti: arr }), () => this.calcolaTotale());
                                                                }} />

                                                            {/* DELETE PRODOTTO ROW */}

                                                            {this.canEdit() &&
                                                                <ManageRowSettings
                                                                    callback={() => {
                                                                        let updated = this.state.prodotti.filter((e, index) => index !== i)
                                                                        this.setState(() => ({ prodotti: updated }), () => {
                                                                            this.calcolaTotale();
                                                                        })
                                                                    }}
                                                                />
                                                            }
                                                        </>
                                                    }

                                                    {/* GIACENZA PRODOTTI CUSTOMER SERVICE */}
                                                    {
                                                        this.state.isUserType === 4 &&
                                                        <TextField
                                                            error={parseInt(el.giacenza) < parseInt(el.quantita)}
                                                            type="number"
                                                            variant="outlined"
                                                            label={'Giacenza magazzino'}
                                                            value={el.giacenza}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    }
                                                    {/* GIACENZA PRODOTTI DA ALTRE PRENOTAZIONI */}
                                                    {
                                                        this.state.isUserType === 4 &&
                                                        <TextField
                                                            // error={el.giacenza < el.quantita}
                                                            type="number"
                                                            variant="outlined"
                                                            label={'Altre prenotazioni'}
                                                            value={parseInt(el.giacenza_uscita) - parseInt(el.quantita)}
                                                            InputProps={{ readOnly: true }}
                                                        />
                                                    }
                                                </Stack>
                                            </div>
                                        )
                                    })

                                }
                            </div>
                        </Stack>

                        {/* FATTURAZIONE E PAGAMENTI */}
                        {
                            (this.state.isUserType !== 4 && !this.state.legato_cliente) &&
                            <Stack spacing={3}>
                                {/* FATTURAZIONE */}
                                <div style={rowTitle}>
                                    <SettingsTitle title="Regole di fatturazione" />
                                    {
                                        this.canEdit() && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('fatturazione')} />
                                    }
                                </div>
                                <p style={{ color: this.state.fatPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.fatPerc) ? 0 : this.state.fatPerc} % coperto</p>

                                <Stack spacing={1}>
                                    {
                                        this.state.fatturazione.map((el, i) => {
                                            return (
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center' key={'fatturazione' + i}>
                                                    {/* Percentuale */}
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.percentage}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.fatturazione]
                                                            arr[i] = { ...arr[i], percentage: e.target.value }
                                                            this.setState({ fatturazione: arr }, () => this.updatePercentage())
                                                        }}
                                                    />
                                                    <Typography>a</Typography>
                                                    {/* Giorni */}
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.days}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.fatturazione]
                                                            arr[i] = { ...arr[i], days: e.target.value }
                                                            this.setState({ fatturazione: arr })
                                                        }}
                                                    />
                                                    <Typography>giorni da </Typography>
                                                    {/* DA */}
                                                    <TextField
                                                        select
                                                        SelectProps={{ readOnly: this.canNotEdit() }}
                                                        value={el.from}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.fatturazione]
                                                            arr[i] = { ...arr[i], from: e.target.value }
                                                            this.setState({ fatturazione: arr })
                                                        }}
                                                    >
                                                        <MenuItem value={'DO'}>DO</MenuItem>
                                                        <MenuItem value={'DC'}>DC</MenuItem>
                                                        <MenuItem value={'DP'}>DP</MenuItem>
                                                    </TextField>
                                                    {/* DELETE FATTURAZIONE ROW */}
                                                    {
                                                        this.canEdit() && <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.fatturazione.filter((e, index) => index !== i)
                                                                this.setState(() => ({ fatturazione: updated }), () => {
                                                                    this.updatePercentage();
                                                                })
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            )
                                        })
                                    }
                                </Stack>

                                {/* INCASSO */}
                                <div style={rowTitle}>
                                    <SettingsTitle title="Regole di incasso" />
                                    {
                                        this.canEdit() && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('incasso')} />
                                    }
                                </div>
                                <p style={{ color: this.state.incPerc !== 100.0 ? 'red' : 'darkgrey', marginTop: -15, marginLeft: 5 }}>{isNaN(this.state.incPerc) ? 0 : this.state.incPerc} % coperto</p>

                                <Stack spacing={1}>
                                    {
                                        this.state.incasso.map((el, i) => {
                                            return (
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} key={'incasso' + i} alignItems='center'>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.percentage}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.incasso]
                                                            arr[i] = { ...arr[i], percentage: e.target.value }
                                                            this.setState({ incasso: arr }, () => this.updatePercentage())
                                                        }}
                                                    />
                                                    <Typography>a</Typography>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.days}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.incasso]
                                                            arr[i] = { ...arr[i], days: e.target.value }
                                                            this.setState({ incasso: arr })
                                                        }}
                                                    />
                                                    <Typography>giorni da </Typography>
                                                    <TextField
                                                        selectProps={{ readOnly: this.canNotEdit() }}
                                                        select
                                                        value={el.from}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.incasso]
                                                            arr[i] = { ...arr[i], from: e.target.value }
                                                            this.setState({ incasso: arr })
                                                        }}
                                                    >
                                                        <MenuItem value={'DO'}>DO</MenuItem>
                                                        <MenuItem value={'DC'}>DC</MenuItem>
                                                        <MenuItem value={'DP'}>DP</MenuItem>
                                                    </TextField>
                                                    {/* DELETE INCASSO ROW */}
                                                    {
                                                        this.canEdit() && <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.incasso.filter((e, index) => index !== i)
                                                                this.setState(() => ({ incasso: updated }), () => {
                                                                    this.updatePercentage();
                                                                })
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            )
                                        })
                                    }
                                </Stack>

                                {/* PROVVIGIONI */}
                                <div style={rowTitle}>
                                    <SettingsTitle title="Regole di provvigioni" />
                                    {
                                        this.canEdit() && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('provvigioni')} />
                                    }
                                </div>

                                <Stack spacing={1}>
                                    {
                                        this.state.provvigioni.map((el, i) => {
                                            return (
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center'>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.percentage}
                                                        onCanPlay={(e) => {
                                                            let arr = [...this.state.provvigioni]
                                                            arr[i] = { ...arr[i], percentage: e.target.value }
                                                            this.setState({ provvigioni: arr })
                                                        }}
                                                    />
                                                    <Typography>a</Typography>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.days}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.provvigioni]
                                                            arr[i] = { ...arr[i], days: e.target.value }
                                                            this.setState({ provvigioni: arr })
                                                        }}
                                                    />
                                                    <Typography>giorni da </Typography>
                                                    <TextField
                                                        selectProps={{ readOnly: this.canNotEdit() }}
                                                        select
                                                        value={el.from}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.provvigioni]
                                                            arr[i] = { ...arr[i], from: e.target.value }
                                                            this.setState({ provvigioni: arr })
                                                        }}
                                                    >
                                                        <MenuItem value={'DO'}>DO</MenuItem>
                                                        <MenuItem value={'DC'}>DC</MenuItem>
                                                        <MenuItem value={'DP'}>DP</MenuItem>
                                                    </TextField>
                                                    {/* DELETE POVVIGIONI ROW */}
                                                    {
                                                        this.canEdit() && <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.provvigioni.filter((e, index) => index !== i)
                                                                this.setState({ provvigioni: updated })
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            )
                                        })
                                    }
                                </Stack>

                                {/* PROVVIGIONI SEGNALATORE */}
                                <div style={rowTitle}>
                                    <SettingsTitle title="Regole di provvigioni (segnalatore)" />
                                    {
                                        this.canEdit() && <img src={require('../images/add.png')} alt="" style={{ cursor: 'pointer', width: 20, height: 20, alignSelf: 'flex-end' }} onClick={() => this.addInputPagamenti('provvigioniSegnalatore')} />
                                    }
                                </div>

                                <Stack spacing={1}>
                                    {
                                        this.state.provvigioniSegnalatore.map((el, i) => {
                                            return (
                                                <Stack direction={"row"} spacing={1} sx={{ flex: 1 }} alignItems='center'>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.percentage}
                                                        onCanPlay={(e) => {
                                                            let arr = [...this.state.provvigioniSegnalatore]
                                                            arr[i] = { ...arr[i], percentage: e.target.value }
                                                            this.setState({ provvigioniSegnalatore: arr })
                                                        }}
                                                    />
                                                    <Typography>a</Typography>
                                                    <TextField
                                                        InputProps={{ endAdornment: <InputAdornment position="end">gg</InputAdornment>, readOnly: this.canNotEdit() }}
                                                        value={el.days}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.provvigioniSegnalatore]
                                                            arr[i] = { ...arr[i], days: e.target.value }
                                                            this.setState({ provvigioniSegnalatore: arr })
                                                        }}
                                                    />
                                                    <Typography>giorni da </Typography>
                                                    <TextField
                                                        SelectProps={{ readOnly: this.canNotEdit() }}
                                                        select
                                                        value={el.from}
                                                        onChange={(e) => {
                                                            let arr = [...this.state.provvigioniSegnalatore]
                                                            arr[i] = { ...arr[i], from: e.target.value }
                                                            this.setState({ provvigioniSegnalatore: arr })
                                                        }}
                                                    >
                                                        <MenuItem value={'DO'}>DO</MenuItem>
                                                        <MenuItem value={'DC'}>DC</MenuItem>
                                                        <MenuItem value={'DP'}>DP</MenuItem>
                                                    </TextField>
                                                    {/* DELETE POVVIGIONI SEGNALATORE ROW */}
                                                    {
                                                        this.canEdit() && <ManageRowSettings
                                                            callback={() => {
                                                                let updated = this.state.provvigioniSegnalatore.filter((e, index) => index !== i)
                                                                this.setState({ provvigioniSegnalatore: updated })
                                                            }}
                                                        />
                                                    }
                                                </Stack>
                                            )
                                        })
                                    }
                                </Stack>
                            </Stack>}

                        <Stack spacing={3} sx={{ mt: 2 }}>
                            <FormControlLabel
                                control={<Android12Switch disabled={this.canNotEdit()} checked={this.state.gru} onChange={() => {
                                    this.setState({ gru: !this.state.gru });
                                }}
                                />}
                                label="Necessaria gru"
                            />
                            <FormControlLabel
                                control={<Android12Switch sx={{ marginLeft: -0.5 }} disabled={this.canNotEdit()} checked={this.state.autotreno} onChange={() => {
                                    this.setState({ autotreno: !this.state.autotreno });
                                }}
                                />}
                                label="Passa autotreno"
                            />
                            {/* TECNICO TRUE OR FALSE */}
                            {
                                this.state.isUserType !== 4 &&
                                <FormControlLabel
                                    disabled={this.canNotEdit()}
                                    control={<Android12Switch sx={{ marginLeft: -0.5 }} checked={this.state.tecnico} onChange={() => {
                                        if (this.state.tecnico) {
                                            this.setState(() => ({ costoTecnico: 0 }), () => this.calcolaTotale());
                                        }
                                        this.setState({ tecnico: !this.state.tecnico })
                                    }
                                    }
                                    />}
                                    label="Richiesto sopralluogo tecnico"
                                />
                            }

                            {/* COSTO TECNICO */}
                            {
                                (this.state.tecnico && this.state.isUserType !== 4) && (
                                    <TextField sx={{ mt: 3 }} type="number" variant="outlined" label={'Costo Tecnico'} value={this.state.costoTecnico}
                                        InputProps={{ startAdornment: <InputAdornment position="start">€ </InputAdornment>, readOnly: this.canNotEdit() }}
                                        onChange={(e) => {
                                            let costo = e.target.value;
                                            this.setState(() => ({ costoTecnico: costo }), () => this.calcolaTotale());
                                        }
                                        } />
                                )
                            }

                            {/* TOTALE CON IVA*/}
                            {
                                this.state.isUserType !== 4 && (
                                    <TextField InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">€ </InputAdornment> }} sx={{ mt: 3 }} variant="outlined" label="Totale con IVA" value={this.state.totale} InputLabelProps={{ shrink: true }} />
                                )
                            }
                            {/* IVA SUL TOTALE */}
                            {
                                this.state.isUserType !== 4 && (
                                    <TextField InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">€ </InputAdornment> }} sx={{ mt: 3 }} variant="outlined" label="IVA Totale" value={this.state.totale * 0.22} InputLabelProps={{ shrink: true }} />
                                )
                            }

                            {
                                this.state.isUserType !== 4 && (
                                    <TextField
                                        select
                                        disabled={this.state.email_inviata === 1 || this.state.approvata || this.state.isUserType !== 0}
                                        key={Math.random()}
                                        label="Tipo ordine"
                                        value={this.state.is_preventivo}
                                        onChange={(e) => {
                                            this.setState({ is_preventivo: e.target.value })
                                        }}
                                        InputProps={{ readOnly: this.state.isUserType === 4 ? true : false }}
                                    >
                                        <MenuItem value={1}>Preventivo</MenuItem>
                                        <MenuItem value={0}>Ordine</MenuItem>
                                    </TextField>
                                )
                            }
                            {/* PREVENTIVO */}
                        </Stack>

                        {this.state.sopralluoghi.length > 0 && <div style={{ height: 30 }}></div>}

                        {/* SOPRALLUOGHI */}
                        {
                            this.state.sopralluoghi.length > 0 && <div style={rowTitle}>
                                <SettingsTitle title="Sopralluoghi tecnici" />
                            </div>
                        }
                        {
                            this.state.sopralluoghi.length > 0 && this.state.sopralluoghi.map((sopralluogo, i) => {
                                return (
                                    <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                                        <TextField
                                            inputProps={{ readOnly: true }}
                                            style={{ width: 300 }}
                                            value={sopralluogo.day}
                                            label="Data sopralluogo"
                                            type="date"
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            readOnly
                                        />
                                        <TextField
                                            fullWidth
                                            inputProps={{ readOnly: true }}
                                            value={sopralluogo.descrizione}
                                            label="Descrizione sopralluogo"
                                            multiline
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Stack>
                                )
                            })
                        }

                        <Stack direction='column' spacing={4} sx={{ flex: 1, mb: 3, mt: 2 }}>
                            {((this.state.isUserType === 0 || this.state.isUserType === 3) && this.state.email_inviata === 1 && this.state.linkPdfConferma === '') &&
                                <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                                    <TextField
                                        sx={{ width: '40%' }}
                                        label="Carica Conferma"
                                        type="file"
                                        variant="outlined"
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(e) => {
                                            let file = e.target.files[0];
                                            let reader = new FileReader();
                                            reader.readAsDataURL(file);
                                            reader.onload = () => {
                                                this.setState({ pdfConferma: reader.result });
                                                this.onChangePdfConferma(username, token, this.state.pdfConferma, this.state.rif, this.state.id);
                                            };
                                            reader.onerror = function (error) {
                                                console.log('Error: ', error);
                                            };
                                            getOrdine(username, token, current).then((res) => {
                                                addReminder(username, token, 'Ordine confermato dal cliente ' + res.rif, 'amministrazione', 'ordine', res.id)
                                            });
                                        }}
                                    />
                                </Stack>
                            }

                            <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 2, mt: 2 }}>

                                {((this.state.isUserType === 0 || this.state.isUserType === 3) && this.state.email_inviata === 1 && this.state.linkPdfConferma !== '') &&
                                    <LoadingButton variant="contained" onClick={() => { window.open(this.state.linkPdfConferma, '_blank'); }} sx={{ height: 50, width: 300, }} >Apri documento di conferma</LoadingButton>
                                }

                                {(this.state.isUserType === 0 && this.state.email_inviata === 1 && this.state.linkPdfConferma !== '') &&
                                    <LoadingButton variant="contained" color="error" onClick={() => this.onDeletePdfConferma(username, token, this.state.id, this.state.rif)} sx={{ height: 50, width: 300 }} >Elimina documento di conferma</LoadingButton>
                                }

                            </Stack>
                        </Stack>

                        {/* DDT */}
                        {this.state.link_ddt.length > 0 && this.state.isUserType !== 3 &&
                            <Stack direction='column' spacing={1} sx={{ flex: 1, mb: 5, pb: 2 }} style={{ ...rowTitle, alignItems: 'flex-start' }}>
                                <SettingsTitle title="DDT" />

                                {(this.state.isUserType === 0 || this.state.isUserType === 4) && this.state.linkPdfDdt.length > 0 && this.state.link_ddt.length > 0 &&
                                    <Stack direction='column' spacing={1} sx={{width: '100%', flex: 1, mb: 2, mt: 0 }}>

                                        {this.state.link_ddt.map((ddt, i) => {
                                            if (ddt.url === '') {
                                                return (
                                                    <Stack direction='row' spacing={4} sx={{ flex: 1, p: 1, display: 'flex', flexDirection: 'row', borderRadius: 1, border: '1px solid darkgrey' }} >
                                                        <TableContainer style={{ width: 'fit-content' }} sx={{ border: 1, borderStyle: 'solid', borderColor: '#ccc' }} className="w-auto" elevation={2}>
                                                            <Table>
                                                                <TableHead>
                                                                    <TableRow style={{ backgroundColor: '#eee' }}>
                                                                        <TableCell align="left" sx={{ borderRight: 1, borderRightStyle: 'solid', borderRightColor: '#ccc', padding: 1, fontWeight: 'bold' }}>Prodotto</TableCell>
                                                                        <TableCell align="center" sx={{ padding: 1, fontWeight: 'bold' }}>Quantità</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {ddt.prodotti && ddt.prodotti.length > 0 && ddt.prodotti.map((row, i) => (
                                                                        <TableRow
                                                                            key={i}
                                                                            sx={{ '&:last-child td, &:last-child th': { borderBottom: 0 } }}
                                                                        >
                                                                            <TableCell align="center" component="th" scope="row" sx={{ borderRightWidth: 1, borderRightStyle: 'solid', borderRightColor: '#ccc', padding: 1 }}>
                                                                                {row.label}
                                                                            </TableCell>
                                                                            <TableCell align="center" sx={{ padding: 1 }}>{row.scansionati}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>

                                                        {!this.state.bloccato && !ddt.approvato && this.state.isUserType === 0 &&
                                                            <LoadingButton
                                                                variant="contained"
                                                                color="success"
                                                                sx={{ height: 50 }}
                                                                onClick={async () => {
                                                                    let new_ddt = [...this.state.link_ddt];
                                                                    new_ddt[i].approvato = true;
                                                                    updateArrayDtt(username, token, new_ddt, current).then(res => {
                                                                        if (res.result === 'ok') {
                                                                            addReminder(username, token, 'DDT approvato ' + this.state.rif, 'service', 'ordine', this.state.id)
                                                                            this.reload()
                                                                        }
                                                                    });
                                                                }}>
                                                                    { this.state.is_parziale ? 
                                                                        (this.state.link_ddt.length === 1 ? 'Approva DDT PARZIALE' : `Approva ${i + 1}° DDT PARZIALE`) :
                                                                    'Approva DDT' }
                                                            </LoadingButton>
                                                        }
                                                        {!this.state.bloccato && !ddt.approvato && this.state.isUserType === 4 &&
                                                            <LoadingButton
                                                                variant="contained"
                                                                color="error"
                                                                sx={{ height: 50 }}
                                                            >
                                                                    { this.state.is_parziale ? 
                                                                        (this.state.link_ddt.length === 1 ? 'In attesa di approvazione da amministrazione' : `In attesa di approvazione del ${i + 1}° DDT PARZIALE da amministrazione`) :
                                                                    'In attesa di approvazione da amministrazione' }
                                                            </LoadingButton>
                                                        }
                                                        {
                                                            ddt.approvato && this.state.isUserType === 0 &&
                                                            <LoadingButton
                                                                variant="contained"
                                                                color="info"
                                                                disableRipple
                                                                sx={{ height: 50 }}
                                                            >
                                                                { this.state.is_parziale ?
                                                                    (this.state.link_ddt.length === 1 ? 'DDT PARZIALE APPROVATO' : `${i + 1}° DDT PARZIALE APPROVATO`) :
                                                                'DDT APPROVATO' }
                                                            </LoadingButton>
                                                        }
                                                        {
                                                            !this.state.bloccato && this.state.isUserType === 4 && ddt.approvato &&
                                                            <LoadingButton sx={{ height: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.setState({
                                                                modalDdt: {
                                                                    show: true,
                                                                    id: current,
                                                                    ddt: ddt,
                                                                    index: i,
                                                                    partial: true,
                                                                    admin: false
                                                                }
                                                            })}>
                                                                {this.state.is_parziale ? 
                                                                    (this.state.link_ddt.length === 1 ? 'Crea DDT PARZIALE' : `Crea ${i + 1}° DDT PARZIALE`) :
                                                                'Crea DDT'}
                                                            </LoadingButton>
                                                        }
                                                    </Stack>
                                                )
                                            }

                                            if (ddt.url !== '' && this.state.linkPdfDdt[i] === '') {
                                                return (
                                                    <Stack direction='column' spacing={2} sx={{ p: 1, borderRadius: 1, border: '1px solid darkgrey' }} >
                                                        <Stack direction='row' spacing={3} >
                                                            {
                                                                this.state.isUserType === 4 &&
                                                                <TextField
                                                                    fullWidth
                                                                    label="Carica Ddt Firmato"
                                                                    type="file"
                                                                    variant="outlined"
                                                                    InputLabelProps={{ shrink: true }}
                                                                    sx={{ flexGrow: 0, maxWidth: 300}}
                                                                    onChange={(e) => {
                                                                        let file = e.target.files[0];
                                                                        let reader = new FileReader();
                                                                        reader.readAsDataURL(file);
                                                                        reader.onload = () => {
                                                                            const new_array = [...this.state.link_ddt];
                                                                            new_array[i].url = reader.result;
                                                                            this.setState({ link_ddt: new_array });
                                                                            this.onChangePdfDdt(username, token, reader.result, this.state.rif, this.state.id, i);
                                                                        };
                                                                        reader.onerror = function (error) {
                                                                            console.log('Error: ', error);
                                                                        };
                                                                    }}
                                                                />
                                                            }

                                                            <LoadingButton
                                                                variant="contained"
                                                                onClick={() => this.setState({
                                                                    modalDdt: {
                                                                        show: true,
                                                                        id: current,
                                                                        ddt: ddt,
                                                                        index: i,
                                                                        partial: true,
                                                                        admin: this.userType === 0
                                                                    }
                                                                })}
                                                                sx={{ height: this.state.isUserType === 4  ? 56 : 50 }} >
                                                                {this.state.linkPdfDdt.length === 1 ? 'Apri DDT non firmato' : `Apri ${i + 1}° DDT non firmato`}
                                                            </LoadingButton>

                                                        </Stack>
                                                        { this.state.isUserType === 4 && <Alert sx={{ flexGrow: 1 }} severity="warning">{this.state.linkPdfDdt.length === 1 ? 'Confermare l\'avvenuta consegna caricando il DDT firmato' : `Confermare l\'avvenuta consegna caricando il ${i + 1}° DDT firmato`}</Alert>}
                                                    </Stack>
                                                )
                                            }
                                            return null;
                                        })}


                                        {this.state.linkPdfDdt.map((pdf, i) => {
                                            if (pdf !== '') {
                                                return (
                                                    <Stack direction='row' spacing={4} sx={{ flex: 1, p: 1, borderRadius: 1, border: '1px solid darkgrey' }}>
                                                        <LoadingButton variant="contained" onClick={() => { window.open(pdf, '_blank'); }} sx={{ height: 50 }} >
                                                            {this.state.linkPdfDdt.length === 1 ? 'Apri documento Ddt firmato' : `Apri ${i + 1}° documento Ddt firmato`}
                                                        </LoadingButton>
                                                        {
                                                            this.state.isUserType === 0 &&
                                                            <LoadingButton variant="contained" color="error" onClick={() => this.onDeletePdfDdt(username, token, this.state.id, this.state.rif, i)} sx={{ height: 50 }} >
                                                                {this.state.linkPdfDdt.length === 1 ? 'Elimina documento Ddt firmato' : `Elimina ${i + 1}° documento Ddt firmato`}
                                                            </LoadingButton>
                                                        }
                                                    </Stack>
                                                )
                                            }
                                            return null 
                                        })}
                                    </Stack>
                                }

                            </Stack>
                        }

                        {/* DATA PRONTO E DATA CONSEGNA */}
                        {this.state.cs_data !== '1' && this.state.isUserType === 4 && <Alert severity="warning" sx={{ marginTop: 2, marginBottom: 5 }}>Inserire una data pronto e una data consegna.</Alert>}
                        {
                            (this.state.isUserType === 4 && this.state.is_preventivo === '0') &&
                            <div style={rowTitle}>
                                <SettingsTitle title="Data pronto e data consegna" />
                            </div>
                        }
                        {
                            (this.state.isUserType === 0 || (this.state.isUserType === 4 && this.state.is_preventivo === '0')) &&   //Check if user is not customer service
                            <Stack direction='row' spacing={4} sx={{ flex: 1, mb: 3, }}>
                                <DatePickerIta
                                    readOnly={this.state.isUserType !== 4}
                                    format='DD/MM/YYYY'
                                    grow
                                    label="Data pronto"
                                    startValue={this.state.data_pronto}
                                    onValueChange={(date) => {
                                        this.setState({ data_pronto: date });
                                    }}
                                />
                                <DatePickerIta
                                    readOnly={this.state.isUserType !== 4}
                                    grow
                                    label="Data consegna"
                                    startValue={this.state.data_consegna}
                                    onValueChange={(date) => {
                                        this.setState({ data_consegna: date });
                                    }}
                                />
                            </Stack>
                        }

                        {
                            this.state.isUserType === 0 &&
                            <Stack >
                                <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 10 }}>
                                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Fatturazione</h3>
                                </Stack>
                                {this.state.fatture.map((f, i) =>
                                    <CustomInfo key={i} testo={'Fattura di € ' + f.importo + ' in data ' + f.data} icona={require('../images/fattura.png')} />
                                )}

                                <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 10 }}>
                                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Incasso</h3>
                                </Stack>
                                {this.state.incassi.map((f, i) =>
                                    <CustomInfo key={i} testo={'Pagamento di € ' + f.importo + ' in data ' + f.data} icona={require('../images/entrata.png')} />
                                )}

                                <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 10 }}>
                                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Provvigioni</h3>
                                </Stack>
                                {this.state.prev_provvigioni.map((f, i) =>
                                    <CustomInfo key={i} testo={'Provvigione di € ' + f.importo + ' in data ' + f.data} icona={require('../images/uscita.png')} />
                                )}

                                <Stack style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 10 }}>
                                    <h3 style={{ marginLeft: 5, marginTop: 15 }}>Provvigioni segnalatore</h3>
                                </Stack>
                                {this.state.prev_provvigioniSegnalatore.map((f, i) =>
                                    <CustomInfo key={i} testo={'Provvigione di € ' + f.importo + ' in data ' + f.data} icona={require('../images/uscita.png')} />
                                )}
                            </Stack>
                        }

                        <div style={{ marginTop: 10 }}></div>
                        {/* PULSANTI AZIONI */}
                        {/* TODO: RIMUOVERE IL PULSANTE QUANDO TUTTO È CONCLUSO */}
                        {this.state.sendError && <Alert severity="error" sx={{ marginTop: 2, marginBottom: 5 }}>Impossibile inviare il messaggio al momento</Alert>}
                        <Stack spacing={3} direction='row' sx={{ alignItems: 'end', flex: 1 }}>
                            {
                                !this.state.bloccato && this.state.email_inviata !== 1 && 
                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading}
                                    onClick={() => {
                                        if (this.state.isUserType !== 4) {
                                            this.save(true)
                                        } else {
                                            this.saveCustomerService()
                                        }
                                    }}
                                >Salva</LoadingButton>
                            }
                            {
                                !this.state.bloccato && this.state.email_inviata === 1 && this.state.isUserType === 4 && this.state.old_data_consegna === '' && this.state.old_data_pronto === '' && 
                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading}
                                    onClick={() => {this.saveCustomerService()}}
                                >Salva Date</LoadingButton>
                            }
                            {
                                (!this.state.bloccato && this.state.crea_ddt === 1 && userType === '4' && this.state.link_ddt.length > 0) && this.state.link_ddt.map((el, i) => {
                                    if (el.approvato && el.url === '') {
                                        return (
                                            <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.setState({
                                                modalDdt: {
                                                    show: true,
                                                    id: current,
                                                    ddt: el,
                                                    index: i
                                                }
                                            })}>
                                                {this.state.linkPdfDdt.length === 1 ? 'Crea DDT' : `Crea ${i + 1}° DDT`}
                                            </LoadingButton>
                                        )
                                    }
                                })
                            }


                            {
                                (!this.state.bloccato && this.state.is_preventivo === '1' && userType === '3') && (
                                    <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => this.transformIntoOrder()}>Trasforma in ordine</LoadingButton>
                                )
                            }
                            {
                                (!this.state.bloccato && userType !== '0' && !this.state.conferma_cliente && this.state.is_preventivo === '0' && this.state.approvata && this.state.email_inviata === 0) && (
                                    <Stack direction='column'>
                                        <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                            if ((this.state.old_data_consegna !== this.state.data_consegna) || (this.state.old_data_pronto !== this.state.data_pronto)) {
                                                alert('Per inviare la conferma è necessario salvare prima le modifiche');
                                                return;
                                            }
                                            inviaCliente(username, token, current).then(res => {
                                                if (res.result === 'ok') {
                                                    let x = {
                                                        show: true,
                                                        link: res.link,
                                                        id_cliente: this.state.cliente,
                                                        id_ordine: current,
                                                        rif: this.state.rif,
                                                        fornitore: false
                                                    };
                                                    this.setState({ modalMail: x });
                                                }
                                            })
                                        }}>Invia al Cliente</LoadingButton>
                                    </Stack>
                                )
                            }
                            {
                                (!this.state.bloccato && userType === '4' && this.state.conferma_magazzino && !this.state.conferma_inviata) && (
                                    <Stack direction='column'>
                                        {this.state.email_inviata === 1 && this.state.linkPdfConferma === '' && <Alert severity="success">Email è stata inviata all'utente, in attesa di conferma</Alert>}
                                        <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                            if ((this.state.old_data_consegna !== this.state.data_consegna) || (this.state.old_data_pronto !== this.state.data_pronto)) {
                                                alert('Per inviare la conferma è necessario salvare prima le modifiche');
                                                return;
                                            }
                                            let x = {
                                                show: true,
                                                email: this.state.email,
                                                ragione_sociale: this.state.ragione_sociale,
                                            };
                                            this.setState({ modalMailConfermaData: x });
                                        }}>Invia Conferma Data</LoadingButton>
                                    </Stack>
                                )
                            }
                            {
                                this.state.is_preventivo === '1' && (
                                    <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                        this.save(false);
                                        visualizzaPreventivo(username, token, current).then(res => {
                                            if (res.result === 'ok') {
                                                window.open(res.link, '_blank');
                                            }
                                        })
                                    }}
                                    >Visualizza anteprima PDF</LoadingButton>
                                )
                            }
                            {
                                !this.state.bloccato && this.state.is_preventivo === '1' && (
                                    <Stack
                                        direction={'column'}
                                    >
                                        {this.state.email_inviata_preventivo && (
                                            <Alert severity="success" sx={{ marginTop: 2, marginBottom: 5 }}>Questo {this.state.is_preventivo === '1' ? 'preventivo' : 'ordine'} è stato inviato</Alert>
                                        )}
                                        <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                            visualizzaPreventivo(username, token, current).then(res => {
                                                if (res.result === 'ok') {
                                                    let x = {
                                                        show: true,
                                                        link: res.link,
                                                        id_cliente: this.state.cliente,
                                                        id_ordine: current,
                                                        rif: this.state.rif,
                                                        fornitore: false,
                                                        is_preventivo: this.state.is_preventivo
                                                    };
                                                    this.setState({ modalMail: x });
                                                }
                                            })
                                        }}
                                        >Invia preventivo</LoadingButton>
                                    </Stack>
                                )
                            }
                            {
                                this.state.isUserType === 0 && this.state.is_preventivo === '0' && (
                                    <>
                                        {
                                            !this.state.approvato && (
                                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                                    editApprovato(username, token, current).then(async res => {
                                                        if (res.result === 'ok') {
                                                            this.setState({ toastAlert: true, toastMessage: 'Ordine approvato!', toastSeverity: 'success' })
                                                            await addReminder(username, token, 'Ordine approvato ' + this.state.rif, 'commerciale', 'ordine', current)
                                                        }
                                                    });
                                                }}>
                                                    {this.state.bloccato ? 'Sblocca ordine' : 'Approva ordine'}
                                                </LoadingButton>
                                            )
                                        }
                                        {
                                            (!this.state.bloccato && this.state.approvato && !this.state.seconda_approvazione && this.state.linkPdfConferma !== '') && (
                                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                                    editSecondaApprovazione(username, token, current).then(async res => {
                                                        if (res.result === 'ok') {
                                                            this.setState({ toastAlert: true, toastMessage: 'Ordine approvato!', toastSeverity: 'success' })
                                                            await addReminder(username, token, 'Ordine approvato ' + this.state.rif, 'commerciale', 'ordine', current)
                                                            await addReminder(username, token, 'Ordine approvato ' + this.state.rif, 'service', 'ordine', current)
                                                            if (this.state.tecnico) {
                                                                await addReminder(username, token, 'Ordine approvato ' + this.state.rif, 'tecnico', 'ordine', current)
                                                            }
                                                        }
                                                    });
                                                }}>Approva ordine firmato</LoadingButton>
                                            )
                                        }
                                        {
                                            (!this.state.bloccato && this.state.approvato && this.state.seconda_approvazione && this.state.linkPdfConferma !== '' && this.state.conferma_cliente && !this.state.terza_approvazione) && (
                                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                                    editTerzaApprovazione(username, token, current).then(async res => {
                                                        if (res.result === 'ok') {
                                                            this.setState({ toastAlert: true, toastMessage: 'Ordine approvato!', toastSeverity: 'success' })
                                                            await addReminder(username, token, 'Approvata lista di carico ' + this.state.rif, 'service', 'ordine', current)
                                                        }
                                                    });
                                                }}>Approva lista di carico</LoadingButton>
                                            )
                                        }
                                        {
                                            !this.state.bloccato && this.ordineProntoChiusura() && !this.state.concluso_magazzino && (
                                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.alert.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                                    editBloccato(username, token, current).then(res => {
                                                        if (res.result === 'ok') {
                                                            this.setState({ toastAlert: true, toastMessage: 'Ordine bloccato!', toastSeverity: 'success' })
                                                        }
                                                    })
                                                }}>Blocca ordine</LoadingButton>
                                            )
                                        }
                                        {
                                            (!this.state.bloccato && !this.state.conclusa && this.state.concluso_magazzino && !this.state.is_parziale && this.ordineProntoChiusura()) && (
                                                <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.primary.main }} variant='contained' loading={this.state.isLoading} onClick={() => {
                                                    editOrdineConcluso(username, token, current)
                                                        .then(res => {
                                                            if (res.result === 'ok') {
                                                                this.setState({ toastAlert: true, toastMessage: 'Ordine concluso!', toastSeverity: 'success' })
                                                                window.location.href = '/#/app/ordini';
                                                            }
                                                        })  
                                                }}>Concludi ordine</LoadingButton>
                                            )
                                        }
                                    </>
                                )
                            }

                            {/* PULSANTI CUSTOMER SERVICE */}
                            {
                                (this.state.isUserType === 4 && !this.state.lista_pronta && this.state.is_preventivo === '0' && this.state.terza_approvazione) && (
                                    <LoadingButton sx={{ minHeight: 50 }} style={{ backgroundColor: _default.palette.alert.main }} variant='contained' loading={this.state.isLoading} onClick={async () => {
                                        createListaCarico(username, token, this.state.id).then(res => {
                                            if (res.result === 'ok') {
                                                this.updateListaPronta();
                                                this.setState({ toastAlert: true, toastMessage: 'Lista di carico creata!', toastSeverity: 'success' })
                                            }
                                        })
                                    }}
                                    >Crea lista di carico</LoadingButton>
                                )
                            }
                        </Stack>
                    </>
                )}
            </>
        );
    }

    async save(reload) {

        if (!this.state.cliente) {
            alert('Inserire un cliente valido');
            return;
        }

        if (!this.state.descrizione) {
            alert('Inserire una descrizione valida');
            return;
        }

        if (this.state.prodotti.length === 0) {
            alert('Inserire un prodotto');
            return;
        }

        if (this.state.tecnico && !this.state.costoTecnico) {
            alert('Inserire un costo per assistenza tecnica valida');
            return;
        }

        if (!this.state.totale) {
            alert('Inserire un totale valido');
            return;
        }

        //CONTROLLO PERCENTUALI
        if (!this.state.legato_cliente) {
            if (this.state.fatPerc !== 100) {
                alert('La somma delle percentuali di fatturazione deve essere 100%');
                return;
            }
            if (this.state.incPerc !== 100) {
                alert('La somma delle percentuali di incasso deve essere 100%');
                return;
            }
        }

        //GENERAZIONE STRINGA AGENTI
        let agentiString = ''
        if (this.state.agente !== '' || this.state.agente != 'Nessun agente') {
            agentiString = this.state.agente + ';'
        }
        if (this.state.segnalatore !== '' && this.state.segnalatore != 'Nessun segnalatore') {
            agentiString += this.state.segnalatore + ';'
        }

        let consegna_max = 0;
        this.state.prodotti.forEach(prodotto => {
            let prodottoConsegna = parseInt(this.state.prodottiList.find((n) => n.id === prodotto.id_prodotto).consegna_max);

            if (prodottoConsegna >= consegna_max) {
                consegna_max = prodottoConsegna;
            }
        });

        let data_ideale = moment().add(consegna_max, 'days').format('DD/MM/YYYY');

        this.setState({ isLoading: true });

        let ordine = {
            id: current,
            cliente: this.state.cliente,
            descrizione: this.state.descrizione,
            prodotti: this.state.prodotti,
            tecnico: this.state.tecnico === true ? '1' : '0',
            autotreno: this.state.autotreno === true ? '1' : '0',
            gru: this.state.gru === true ? '1' : '0',
            indirizzo: this.state.indirizzo,
            costoTecnico: this.state.costoTecnico || 0,
            is_preventivo: this.state.is_preventivo,
            totale: this.state.totale,
            link_conferma: this.state.linkPdfConferma,
            link_ddt: this.state.linkPdfDdt,
            id_agente: agentiString,
            id_funzionario: this.state.funzionario,
            legato_cliente: this.state.legato_cliente,
            fatturazione: this.state.fatturazione,
            pagamento: this.state.incasso,
            provvigioni: this.state.provvigioni,
            segnalatore: this.state.provvigioniSegnalatore,
            cantiere: this.state.riferimento_cantiere,
            consegna_max: data_ideale,
            rif: this.state.rif,
        };

        let res = await editOrdine(username, token, ordine);
        if (res.result === 'ok') {
            if (reload) {
                window.location.href = this.state.is_preventivo === '0' ? this.state.ordiniLink : this.state.preventiviLink;
            } else {
                this.setState({ isLoading: false })
            }
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dell\'ordine. Per favore, riprova.');
    }

    async transformIntoOrder() {
        if (window.confirm('Sei sicuro di voler trasformare il preventivo in un ordine ?')) {
            intoOrder(username, token, current).then(res => {
                if (res.result === 'ok') {
                    addReminder(username, token, 'Preventivo trasformato in ordine ' + this.state.rif, 'amministrazione', 'ordine', current)
                    window.location.href = this.state.ordiniLink;
                }
            })
        }
    }

    async saveCustomerService() {
        current = cookies.get('ordine', { path: '/' });

        // CONTROLLO DATE PRONTO E CONSEGNA
        if (moment(this.state.data_consegna, 'DD/MM/YYYY').isBefore(moment(this.state.data_pronto, 'DD/MM/YYYY'))) {
            alert('La data di consegna non può essere precedente alla data di pronto');
            return;
        }
        if (moment(this.state.data_pronto, 'DD/MM/YYYY').isBefore(moment())) {
            alert('La data di pronto non può essere precedente alla data odierna');
            return;
        }
        if (moment(this.state.data_consegna, 'DD/MM/YYYY').isBefore(moment())) {
            alert('La data di consegna non può essere precedente alla data odierna');
            return;
        }
        if (this.state.data_pronto === '') {
            alert('Inserire una data di pronto');
            return;
        }
        if (this.state.data_consegna === '') {
            alert('Inserire una data di consegna');
            return;
        }

        editOrdineCs(username, token, current, this.state.data_pronto, this.state.data_consegna)
            .then(async res => {
                if (res.result === 'ok') {
                    await addReminder(username, token, 'Date ordine aggiornato ' + this.state.rif, 'magazzino', 'notifica ordine', current);
                    await addReminder(username, token, 'Date ordine aggiornato ' + this.state.rif, 'amministrazione', 'ordine', current);
                    this.setState({ toastAlert: true, toastMessage: 'Ordine aggiornato', toastSeverity: 'success' })
                    this.state.old_data_consegna = this.state.data_consegna;
                    this.state.old_data_pronto = this.state.data_pronto;
                    if (this.state.cs_data === '0') {
                        window.location.reload();
                    }
                } else {
                    this.setState({ toastAlert: true, toastMessage: 'Si è verificato un errore', toastSeverity: 'error' })
                }
            }
            )
    }

    async updateListaPronta() {
        getOrdine(username, token, current).then(res => {
            if (res.result === 'ok') {
                this.setState({ toastAlert: true, toastMessage: 'Si è verificato un errore', toastSeverity: 'error' })
                return
            }

            if (res.data_pronto === null || res.data_consegna === null) {
                alert('Salvare una data valida di pronto e consegna');
                return;
            }

            if (!moment(res.data_pronto.replaceAll('/', '-'), 'DD-MM-yyyy', true).isValid() || !moment(res.data_consegna.replaceAll('/', '-'), 'DD-MM-yyyy', true).isValid()) {
                alert('Salvare una data valida di pronto e consegna');
                return;
            }

            editOrdineListaPronta(username, token, current).then(res => {
                if (res.result === 'ok') {
                    this.setState({ toastAlert: true, toastMessage: 'Lista di carico creata', toastSeverity: 'success', lista_pronta: true })

                } else {
                    this.setState({ toastAlert: true, toastMessage: 'Si è verificato un errore', toastSeverity: 'error' })
                }
            })
            addReminder(username, token, 'Lista di carico pronta ' + res.rif, 'magazzino', 'notifica ordine', current)
        })
    }

    getStringImporto(importo) {
        var imp = String(importo);
        var chunks = imp.split('.');
        chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        if (chunks.length > 1 && chunks[1] === '00') {
            return chunks[0];
        }
        return chunks.join(',');
    }

    elaborateScheduleFatturazione() {
        let imp = parseFloat(this.state.totale.replace(/\./g, '').replace(/,/g, '.'));
        var fatture = [];
        for (const f of this.state.fatturazione) {
            var importo = this.getStringImporto((imp * (parseFloat(f.percentage) / 100)).toFixed(2));
            if (!this.state.data_pronto || !this.state.data_consegna || this.state.data_consegna === '' || this.state.data_pronto === '') {
                fatture.push({ importo: importo, data: 'da definire' });
                continue;
            }
            var temp = _.cloneDeep(f.from === 'DO' ? this.state.data_creazione.split(' ')[0].split('-').reverse().join('/') : f.from === 'DC' ? this.state.data_consegna : this.state.data_pronto);
            let data = moment(temp, 'DD/MM/YYYY').add(f.days, 'days').format('DD/MM/YYYY');
            fatture.push({ importo: importo, data: data });
        }
        this.setState({ fatture });
    }


    elaborateScheduleIncassi() {
        let imp = parseFloat(this.state.totale.replace(/\./g, '').replace(/,/g, '.'));
        var incassi = [];
        for (const f of this.state.incasso) {
            let importo = this.getStringImporto((imp * (parseFloat(f.percentage) / 100)).toFixed(2));
            if (!this.state.data_pronto || !this.state.data_consegna || this.state.data_consegna === '' || this.state.data_pronto === '') {
                incassi.push({ importo: importo, data: 'da definire' });
                continue;
            }
            var temp = _.cloneDeep(f.from === 'DO' ? this.state.data_creazione.split(' ')[0].split('-').reverse().join('/') : f.from === 'DC' ? this.state.data_consegna : this.state.data_pronto);
            let data = moment(temp, 'DD/MM/YYYY').add(f.days, 'days').format('DD/MM/YYYY');
            incassi.push({ importo: importo, data: data });
        }
        this.setState({ incassi });
    }

    elaborateScheduleProvvigioni() {
        let imp = parseFloat(this.state.totale.replace(/\./g, '').replace(/,/g, '.'));
        var prev_provvigioni = [];
        for (const f of this.state.provvigioni) {
            let importo = this.getStringImporto((imp * (parseFloat(f.percentage) / 100)).toFixed(2));
            if (!this.state.data_pronto || !this.state.data_consegna || this.state.data_consegna === '' || this.state.data_pronto === '') {
                prev_provvigioni.push({ importo: importo, data: 'da definire' });
                continue;
            }
            var temp = _.cloneDeep(f.from === 'DO' ? this.state.data_creazione.split(' ')[0].split('-').reverse().join('/') : f.from === 'DC' ? this.state.data_consegna : this.state.data_pronto);
            let data = moment(temp, 'DD/MM/YYYY').add(f.days, 'days').format('DD/MM/YYYY');
            prev_provvigioni.push({ importo: importo, data: data });
        }
        this.setState({ prev_provvigioni });
    }

    elaborateScheduleProvvigioniSegnalatore() {
        let imp = parseFloat(this.state.totale.replace(/\./g, '').replace(/,/g, '.'));
        var prev_provvigioniSegnalatore = [];
        for (const f of this.state.provvigioniSegnalatore) {
            let importo = this.getStringImporto((imp * (parseFloat(f.percentage) / 100)).toFixed(2));
            if (!this.state.data_pronto || !this.state.data_consegna || this.state.data_consegna === '' || this.state.data_pronto === '') {
                prev_provvigioniSegnalatore.push({ importo: importo, data: 'da definire' });
                continue;
            }
            var temp = _.cloneDeep(f.from === 'DO' ? this.state.data_creazione.split(' ')[0].split('-').reverse().join('/') : f.from === 'DC' ? this.state.data_consegna : this.state.data_pronto);
            let data = moment(temp, 'DD/MM/YYYY').add(f.days, 'days').format('DD/MM/YYYY');
            prev_provvigioniSegnalatore.push({ importo: importo, data: data });
        }
        this.setState({ prev_provvigioniSegnalatore });
    }
}

const selectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopLeftRadius: 15,
    borderBottomLeftRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

const rightSelectionButton = {
    height: 30,
    width: 140,
    marginLeft: 5,
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
    textAlign: 'center',
    paddingTop: 4,
    cursor: 'pointer'
}

